/* eslint-disable @typescript-eslint/no-var-requires */
const ComponentsList = {
  Input: require('../input').default,
  SelectInput: require('../select-input').default,
  Textarea: require('../textarea').default,
  Checkbox: require('../checkbox').default,
  Autocomplete: require('../autocomplete').default
}

export default ComponentsList
